import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useSidebarStore = create(
  persist(
    (set, get) => ({
      // State
      conversations: [],
      searchQuery: '',
      isCollapsed: false,
      editingId: null,
      isLoading: false,

      // Actions
      setConversations: (conversations) => set({ conversations }),

      addConversation: (conversation) => set((state) => ({
        conversations: [conversation, ...state.conversations]
      })),

      setSearchQuery: (query) => set({ searchQuery: query }),

      toggleSidebar: () => set((state) => ({
        isCollapsed: !state.isCollapsed
      })),

      setCollapsed: (collapsed) => set({ isCollapsed: collapsed }),

      setEditingId: (id) => set({ editingId: id }),

      setLoading: (loading) => set({ isLoading: loading }),

      updateConversationTitle: (id, title) => set((state) => ({
        conversations: state.conversations.map((c) =>
          c.id === id ? { ...c, title, updatedAt: new Date().toISOString() } : c
        )
      })),

      updateConversationMessages: (id, messages, updateTimestamp = false) => set((state) => ({
        conversations: state.conversations.map((c) =>
          c.id === id
            ? {
                ...c,
                messages,
                messageCount: messages.length,
                ...(updateTimestamp && { updatedAt: new Date().toISOString() })
              }
            : c
        )
      })),

      deleteConversation: (id) => set((state) => ({
        conversations: state.conversations.filter((c) => c.id !== id)
      })),

      // Getters
      getFilteredConversations: () => {
        const { conversations, searchQuery } = get();
        if (!searchQuery.trim()) return conversations;

        const query = searchQuery.toLowerCase();
        return conversations.filter((c) =>
          c.title.toLowerCase().includes(query) ||
          c.messages?.some(m => m.content.toLowerCase().includes(query))
        );
      }
    }),
    {
      name: 'labs-sidebar-store',
      partialize: (state) => ({
        isCollapsed: state.isCollapsed
      })
    }
  )
);
